import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DatePipe} from '@angular/common';
import {DataService} from '../data.service';
import {LoggerService} from '../../shared/common-components/logger.service';
import {Observable, catchError} from 'rxjs';
import {ControlKeys, ControlKeysFrt} from '../../features/ratefile-open/control-keys';

@Injectable({
  providedIn: 'root'
})
export class RatefileOpenService extends DataService {

  private baseURI = this.apiUri + '/ratefileopen/';
  private observable$: any;
  private _logger: LoggerService;
  private datePipe: DatePipe;

  constructor(http: HttpClient, logger: LoggerService) {
    super(http);
    this._logger = logger;
  }

  getRateFileRecord(controlType: string, fileType: string): Observable<any> {
    this.setUri(this.baseURI + controlType + '/controltype/' + fileType + '/filingtype');
    return this.http.get(this.baseURI + controlType + '/controltype/' + fileType + '/filingtype');
  }

  getRateFileRecordForControlType(controlType: string): Observable<any> {
    // this.setUri(this.baseURI + controlType + '/controltype/');
    // return this.http.get(this.baseURI + controlType + '/controltype/');
    this.setUri(this.baseURI + controlType + '/controltype/frt');
    return this.http.get(this.baseURI + controlType + '/controltype/frt');
  }

  getPcMilerForHhg(controlType, filingType) {
    this.setUri(this.baseURI + controlType + '/controltype' + filingType + '/filingtype');
    return this.http.get(this.baseURI + controlType + '/controltype/' + filingType + '/filingtype');
  }

  getRateFileRecorForId(controlId: number): Observable<any> {
    this.setUri(this.baseURI + controlId + '/controlid/');
    return this.http.get(this.baseURI + controlId + '/controlid/');
  }
  getRateFileRecorForIdFrt(controlId: number): Observable<any> {
    this.setUri(this.baseURI + controlId + '/controlid/frt');
    return this.http.get(this.baseURI + controlId + '/controlid/frt');
  }
  createControlKeys(controlKeys: ControlKeys): Observable<any> {
    return this.http.post(this.baseURI + 'savecontrolkeys/', controlKeys).pipe(catchError(this.handleError));
  }
  createControlKeysFrt(controlKeysFrt: ControlKeysFrt): Observable<any> {
    return this.http.post(this.baseURI + 'savecontrolkeysfrt/', controlKeysFrt).pipe(catchError(this.handleError));
  }

  sendEmail(controlId: number): Observable<any> {
    this.setUri(this.baseURI + 'email/' + controlId + '/controlid/');
    return this.http.get(this.baseURI + 'email/' + controlId + '/controlid/');
  }

}


